<script>
import appConfig from "@/app.config";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Résultat non trouvé",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout
  },
}
</script>
<template>
  <Layout>
    <div class="account-pages my-5 pt-5">
      <div class="container">
        <div class="row">

          <div class="col-lg-12 text-center">
            <div class="text-center mb-5">

              <h1 class="display-2 text-dark font-weight-medium">
                4<i class="bx bx-buoy bx-spin text-primary display-3"></i>4
              </h1>

              <h3 class="text-primary text-uppercase mt-4">
                Résultat non trouvé !
              </h3>

              <h4 class="text-dark mt-2">Nous sommes désolés, la page que vous cherchez n'a pas été trouvée.</h4>
              
              <router-link to="/">
                <b-button type="submit" variant="outline-primary"  
                      style="width: 166px;margin: auto;"
                      class="btn-block mt-4 font-weight-bold font-size-16 mt-5">Retour à l' Accueil</b-button>
              </router-link>

            </div>
          </div>

        </div>
      </div>
    </div>
  </Layout>













 
</template>

